var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-page"},[_c('ProductsListingContainer',{attrs:{"entity-type":"search","param-top-category":_vm.paramTopCategory,"param-category":_vm.paramCategory,"param-sub-category":_vm.paramSubCategory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }